<template>
  <div id="Calendar_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            社區行事曆
          </div>
          <div class="tip">
            可線上立即檢視日曆與輕鬆掌握社區所有重要的活動
          </div>
        </div>
      </div>
      <div class="title_bar">
        <div class="left">
          <!-- 範例留用 -->
          <!-- <span class="questionnaire">喜歡這次改版嗎？<span @click="$toExternaLink('https://forms.gle/LsEeZ8guCZYZ5EBBA')">點此填寫滿意度調查！</span></span> -->
        </div>
        <div class="right">
          <el-button
            icon="icon-plus"
            type="primary"
            round
            @click="calendarDate()"
          >
            新增活動
          </el-button>
        </div>
      </div>
      <div
        v-loading="loading"
        class="calendar_content"
      >
        <div class="list">
          <CalendarList
            ref="calendarList"
            :data="calendarData"
            :calendar-value="calendarValue"
            @goMonth="goMonth"
            @goEvent="goEvent"
            @changeYear="changeYear"
          />
        </div>
        <div class="calendar">
          <div class="buttonGroup">
            <el-button
              id="calendar-button-3"
              type="primary"
              size="medium"
              plain
              @click="goToday"
            >
              今天
            </el-button>
            <div
              id="calendar-button-1"
              class="changeMonth"
              @click="changeMonth('last')"
            >
              <i
                class="icon-m-back"
                aria-hidden="true"
              />
            </div>
            <div
              id="calendar-button-2"
              class="changeMonth"
              @click="changeMonth('next')"
            >
              <i
                class="icon-m-next"
                aria-hidden="true"
              />
            </div>
          </div>
          <el-calendar
            v-model="calendarValue"
            :first-day-of-week="7"
          >
            <template
              slot="dateCell"
              slot-scope="{data}"
            >
              <div
                class="calendarDate"
                @click="calendarDate(data.day)"
              />
              <div
                v-if="data.day.split('-').slice(2).join('-')<10"
                class="calendar-day"
              >
                {{ data.day.split('-').slice(2).join('-').slice(1) }}
              </div>
              <div
                v-else
                class="calendar-day"
              >
                {{ data.day.split('-').slice(2).join('-') }}
              </div>
              <div class="createbutton">
                <i
                  class="icon-plus"
                  aria-hidden="true"
                />
              </div>
              <div
                v-for="(item ,index) in calendarData"
                :key="index"
              >
                <div v-if="(item.CalendarTime.StartDate).indexOf(data.day) !== -1">
                  <!-- 活動細節彈窗 -->
                  <el-popover
                    v-model="item.PopoverValue"
                    placement="top"
                    width="320"
                    trigger="click"
                    popper-class="calendarPopover"
                    @after-enter="popoverVisible = true ; popoverVisibleIndex = index"
                    @hide="popoverHide(index)"
                  >
                    <el-form
                      label-position="top"
                      label-width="80px"
                      size="mini"
                    >
                      <i
                        class="icon-cancel"
                        aria-hidden="true"
                        @click="item.PopoverValue = false"
                      />
                      <el-form-item label="活動">
                        <div
                          v-if="item.Color !== ''"
                          class="title"
                        >
                          <span :style="'color:' + item.Color">{{ item.Title }}</span>
                          <el-tag
                            effect="dark"
                            :style="'backgroundColor:' + item.Color"
                          >
                            {{ browseTypeList[item.BrowseType] }}
                          </el-tag>
                        </div>
                        <div
                          v-else
                          class="title"
                        >
                          <span :style="'color:' + presetColor[item.ColorType]">{{ item.Title }}</span>
                          <el-tag
                            effect="dark"
                            :style="'backgroundColor:' + presetColor[item.ColorType]"
                          >
                            {{ browseTypeList[item.BrowseType] }}
                          </el-tag>
                        </div>
                      </el-form-item>
                      <el-form-item label="時間">
                        <div class="time">
                          {{ item.CalendarTime.continuousEventStartDate.substring(5,7) }}月
                          {{ item.CalendarTime.continuousEventStartDate.substring(8,10) }}日
                          （週{{ item.CalendarTime.StartWeek }}）－
                          {{ item.CalendarTime.EndDate.substring(5,7) }}月
                          {{ item.CalendarTime.EndDate.substring(8,10) }}日
                          （週{{ item.CalendarTime.EndWeek }}）
                          <br>
                          <span v-if="item.CalendarTime.StartTime.substring(0,2) < 12 ">上午</span>
                          <span v-else>下午</span>
                          {{ item.CalendarTime.StartTime.substring(0,5) }}
                          <span v-if="item.CalendarTime.EndTime.substring(0,2) < 12 ">－上午</span>
                          <span v-else>－下午</span>
                          {{ item.CalendarTime.EndTime.substring(0,5) }}
                        </div>
                      </el-form-item>
                      <el-form-item label="地點">
                        {{ item.Location || '無' }}
                      </el-form-item>
                      <el-form-item label="描述">
                        <span v-if="item.Description === ''">無</span>
                        <div
                          v-else
                          class="description"
                        >
                          {{ item.Description }}
                        </div>
                      </el-form-item>
                      <el-form-item label="附加檔案">
                        <span v-if="item.Files.length === 0">無附加檔案</span>
                        <div
                          v-else
                          class="files"
                        >
                          <a
                            v-for="(item ,index) in item.Files"
                            :key="index"
                            :href="item.FileUri"
                            class="fileName"
                            target="_bkank"
                          >
                            <i
                              class="icon-clip"
                              aria-hidden="true"
                            />
                            <span>附檔{{ index+1 }}.{{ item.FileUri.split('?')[0].split('.').pop().toLowerCase() }}</span>
                            <span>({{ item.FileSize }}KB)</span>
                          </a>
                        </div>
                      </el-form-item>
                      <div class="buttonDiv">
                        <el-button
                          size="mini"
                          plain
                          @click="delEvent(item.Id)"
                        >
                          刪除
                        </el-button>
                        <el-button
                          size="mini"
                          type="primary"
                          class="editButton"
                          @click="editEvent(item, index)"
                        >
                          編輯活動
                        </el-button>
                      </div>
                    </el-form>
                    <!-- 活動 -->
                    <div
                      :id="'eventTag'+item.Id"
                      slot="reference"
                      @click="popoverVisible = true ; popoverVisibleIndex = index"
                    >
                      <!-- 全天活動樣式 -->
                      <div
                        v-if="item.CalendarTime.IsAllDay"
                        class="event"
                        :style="item.Color !== '' ? 'background-color:' + item.Color : 'background-color:' + presetColor[item.ColorType]"
                      >
                        {{ item.Title }}
                      </div>
                      <!-- 非全天活動樣式 -->
                      <div
                        v-else
                        class="notAllDay"
                      >
                        <div
                          class="eventDot"
                          :style="item.Color !== '' ? 'background-color:' + item.Color : 'background-color:' + presetColor[item.ColorType]"
                        />
                        <div class="title">
                          {{ item.Title }}
                        </div>
                        <div class="eventStartTime">
                          {{ item.CalendarTime.StartTime.substring(0,5) }}
                        </div>
                      </div>
                    </div>
                    <!-- 活動 -->
                  </el-popover>
                </div>
              </div>
            </template>
          </el-calendar>
        </div>
      </div>
    </div>
    <EventDialog
      ref="eventDialog"
      @getAnnualEventList="getAnnualEventList"
      @deleteEvent="deleteEvent"
    />
  </div>
</template>
<script>
import CalendarList from '../Calendar/components/CalendarList'
import EventDialog from '../Calendar/components/EventDialog'

export default {
  components: {
    CalendarList,
    EventDialog
  },
  data () {
    return {
      presetColor: ['#29b6d8', '#51bf87', '#777777', '#f8ac59', '#ec4758', '#29b6d8'], // 預設顏色，因疑似有髒資料故加入第5個顏色，以解決ColorType=5但Color=""的情境
      calendarData: [],
      calendarValueYear: 0,
      calendarValue: new Date(),
      browseTypeList: ['全社區', '委員會', '樓管'],
      popoverVisible: false,
      popoverVisibleIndex: '',
      clickcalendarDate: false,
      delEventAlert: false,
      loading: false,
      canClickButton: true
    }
  },
  watch: {
    calendarValue: function (newValue, oldValue) {
      if (this.calendarValue.getFullYear() !== this.calendarValueYear) { // 切換年份
        this.getAnnualEventList(this.calendarValue.getFullYear())
        this.getMonth()
        this.popoverVisibleIndex = ''
      } else {
        // eslint-disable-next-line eqeqeq
        if (newValue.getMonth() != oldValue.getMonth()) {
          this.getMonth()
          if (this.popoverVisibleIndex !== '' && this.calendarData[this.popoverVisibleIndex].PopoverValue) { this.popoverHide(this.popoverVisibleIndex) }
        }
      }
      console.log('切換' + this.calendarValue)
    }
  },
  mounted () {
    this.getMonth()
    this.getAnnualEventList(new Date().getFullYear())
    this.$refs.calendarList.updateOffsetTop()
  },
  methods: {
    // 取得年度活動
    getAnnualEventList (year) {
      this.loading = true
      const requestData = {
        year
      }
      apiCalendar.GetAnnualEventList(
        requestData
      ).then((res) => {
        if (res.status === 200) {
          this.calendarValueYear = year
          const day_list = ['日', '一', '二', '三', '四', '五', '六']
          const continuousEventData = [] // 處理連續活動
          res.data.Data.forEach(item => {
            if (continuousEventData.length === 0) {
              continuousEventData.push({
                Id: item.Id,
                StartDate: item.CalendarTime.StartDate
              })
              item.CalendarTime.continuousEventStartDate = item.CalendarTime.StartDate
            } else if (continuousEventData[continuousEventData.length - 1].Id !== item.Id) {
              continuousEventData.push({
                Id: item.Id,
                StartDate: item.CalendarTime.StartDate
              })
              item.CalendarTime.continuousEventStartDate = item.CalendarTime.StartDate
            } else {
              item.CalendarTime.continuousEventStartDate = continuousEventData[continuousEventData.length - 1].StartDate
            }
            item.PopoverValue = false
            item.CalendarTime.StartWeek = day_list[new Date(item.CalendarTime.continuousEventStartDate).getDay()]
            item.CalendarTime.EndWeek = day_list[new Date(item.CalendarTime.EndDate).getDay()]
          })
          this.calendarData = [...res.data.Data]
          this.loading = false
          this.popoverVisible = false
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    getMonth () {
      const month = this.calendarValue.getMonth()
      const month_list = ['1月 January', '2月 February', '3月 March', '4月 April', '5月 May', '6月 June', '7月 July', '8月 August', '9月 September', '10月 October', '11月 November', '12月 December']
      document.querySelector('.el-calendar__title').textContent = month_list[month]
      const th = document.querySelector('.el-calendar-table').getElementsByTagName('thead')[0].children
      for (let i = 0; i < 7; i++) {
        th[i].innerHTML = '週' + ['日', '一', '二', '三', '四', '五', '六'][i]
      }
    },
    changeMonth (type) {
      document.getElementById('calendar-button-1').blur()
      document.getElementById('calendar-button-2').blur()
      if (this.popoverVisible) { return }
      const date = new Date(this.calendarValue)
      date.setDate(1)
      const month = type === 'last' ? date.getMonth() - 1 : date.getMonth() + 1
      date.setMonth(month)
      this.calendarValue = date
    },
    goToday () {
      document.getElementById('calendar-button-3').blur()
      if (this.popoverVisible) { return }
      this.calendarValue = new Date()
    },
    editEvent (data, index) {
      if (this.canClickButton) {
        this.canClickButton = false
        this.popoverHide(index)
        this.$refs.eventDialog.openDialog('編輯', data, this.calendarValue)
        setTimeout(() => {
          this.canClickButton = true
        }, 2000)
      }
    },
    delEvent (eventId) {
      if (this.canClickButton) {
        this.canClickButton = false
        this.delEventAlert = true
        this.$confirm('確認刪除活動？', '警告', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.deleteEvent(eventId)
          this.delEventAlert = false
        }).catch(() => {
          this.delEventAlert = false
        })
        setTimeout(() => {
          this.canClickButton = true
        }, 2000)
      }
    },
    deleteEvent (eventId) {
      apiCalendar.DeleteEvent({
        eventId
      }).then((res) => {
        if (res.status === 200) {
          this.$message({
            message: '刪除成功',
            type: 'success'
          })
          this.getAnnualEventList(new Date(this.calendarValue).getFullYear())
        }
      }).catch((err) => {
        if (err.response.status === 404) {
          this.getAnnualEventList(new Date(this.calendarValue).getFullYear())
          this.$message({
            message: '此活動已刪除',
            type: 'warning'
          })
        } else {
          console.log('錯誤訊息：', err.response)
        }
      })
    },
    calendarDate (date) {
      if (!this.popoverVisible) {
        if (date) {
          console.log(date)
          this.$refs.eventDialog.openDialog('新增', date, this.calendarValue)
        } else {
          const today = (this.$newFormatDate(new Date())).substring(0, 10)
          console.log(today)
          this.$refs.eventDialog.openDialog('新增', today, this.calendarValue)
        }
      }
    },
    popoverHide (index) {
      this.popoverVisibleIndex = ''
      if (this.delEventAlert) {
        this.calendarData[index].PopoverValue = true
        this.$nextTick(() => {
          const index = document.getElementsByClassName('calendarPopover').length - 1
          document.getElementsByClassName('calendarPopover')[index].style.zIndex = 2001
        })
        return
      }
      this.calendarData[index].PopoverValue = false
      this.popoverVisible = false
    },
    // 活動列表click月份，要切換月份
    goMonth (date) {
      if (this.popoverVisible) { return }
      this.calendarValue = date
    },
    // 活動列表click活動，要切換月份並打開popover
    goEvent (index, date) {
      this.calendarValue = date
      // 若直接改寫PopoverValue的值為true，後續又會變成false
      // 但trace不到是哪裡改的，不得已只好使用setTimeout延後
      setTimeout(() => {
        this.calendarData[index].PopoverValue = true
      })
    },
    // 活動列表切換年份
    changeYear (type) {
      const date = new Date(this.calendarValue)
      const year = type === 'last' ? this.calendarValue.getFullYear() - 1 : this.calendarValue.getFullYear() + 1
      date.setFullYear(year)
      this.calendarValue = date
    }
  }
}
</script>
<style lang="sass" scoped>
#Calendar_main
  +mainLayer
  .main
    .calendar_content
      display: flex
      .list
        flex: 1.1
        width: 200px
      .calendar
        flex: 5
        position: relative
        .buttonGroup
          position: absolute
          top: 20px
          right: 24px
          .el-button
            position: relative
            top: -2px
            margin-right: 20px
          .changeMonth
            margin: 10px
            display: inline-block
            i
              cursor: pointer
              color: $mainColor
              font-size: 18px
        ::v-deep .el-calendar
          border: solid 1px $bgDark3
          border-radius: $pageBorderRadius
          margin-left: 8px
          padding: 24px
          .el-calendar__header
            padding: 0
            border-bottom: 0
          .el-calendar__body
            padding: 0
            margin-top: 20px
          .el-calendar__title
            font-size: 26px
            font-weight: bold
            color: $mainFontColor
          .el-calendar-table
            th
              color: $mainFontColor
              font-weight: 700
              font-size: 17px
          td
            cursor: pointer
            height: 110px
            width: 125px
            &.is-selected
              background-color: transparent
            &.is-today
              .calendar-day
                background-color: $mainColor
                color: $white
                border-radius: 45px
            &.next,&.prev
              .event
                display: none
          .el-calendar__button-group
            display: none
          .el-calendar-day
            height: 140px
            padding: 4px
            position: relative
            overflow: auto
            &:hover
              background-color: transparent
              .createbutton
                display: block
            .calendarDate
              position: absolute
              top: 0
              left: 0
              width: 100%
              height: 100%
              z-index: 2
            .calendar-day
              font-weight: 600
              width: 24px
              margin: 0 auto
              line-height: 24px
            .createbutton
              display: none
              position: absolute
              top: 5px
              right: 5px
              padding: 3px 5px
              background-color: $bgDark3
              border-radius: $btnSquareBorderRadius
              i
                font-size: 13px
                color: $mainColor
            .event
              z-index: 3
              position: relative
              text-align: left
              font-size: 14px
              cursor: pointer
              text-overflow: ellipsis
              white-space: nowrap
              overflow: hidden
              color: $white
              margin-bottom: 4px
              padding-left: 4px
              border-radius: 4px
              height: 20px
              line-height: 20px
              &:hover
                &::before
                  height: 20px
                  width: 100%
                  box-sizing: border-box
                  border-radius: 4px
                  content: ''
                  background-color: rgba(0, 0, 0, 0.08) !important
                  position: absolute
                  top: 0
                  right: 0
            .notAllDay
              z-index: 3
              margin-bottom: 4px
              display: flex
              position: relative
              line-height: 14px
              font-size: 14px
              width: 100%
              box-sizing: border-box
              padding: 3px
              border-radius: 4px
              &:hover
                background-color: rgba(0, 0, 0, 0.08)
              .eventDot
                position: absolute
                top: 8px
                width: 4px
                height: 4px
                border-radius: 45px
              .title
                width: calc( 100% - 26px )
                text-overflow: ellipsis
                white-space: nowrap
                overflow: hidden
                text-align: left
                margin-left: 7px
                color: $mainFontColor
              .eventStartTime
                position: absolute
                right: 3px
                line-height: 14px
                width: 30px
                font-size: 11px
                color: #808080
      ::v-deep .el-loading-mask
        z-index: 1999
</style>
<style lang="sass">
.el-popover,.el-popper,.calendarPopover
  background-color: $white
  color: $mainFontColor
  .el-form
    position: relative
    .icon-cancel
      position: absolute
      right: 0px
      top: 0px
      cursor: pointer
      font-size: 15px
    .el-form-item--mini .el-form-item__label
      padding-bottom: 0px
      color: #888
      font-size: 15px
    .el-form-item__content
      font-size: 16px
      .title
        font-weight: bold
        .el-tag
          margin-left: 5px
          color: $white
      .time
        font-weight: bold
    .description
      white-space: break-spaces
      height: 150px
      overflow: auto
    .files
      .fileName
        display: block
        color: $mainFontColor
        cursor: pointer
        &:hover
          text-decoration: underline
      .icon-clip
        display: inline-block
        margin-right: 5px
        &:hover
          text-decoration: none
    .buttonDiv
      margin: 0px auto
      position: relative
      border-top: $borderDark1 1px solid
      padding-top: 20px
      .editButton
        right: 0
        position: absolute
.el-popper[x-placement^="top"] .popper__arrow
  &::after
    border-top-color: $white
</style>
